import { Search } from "lucide-react";
import { useState } from "react";

const Heading = ({
  buttonName = "Add New",
  onButtonClick,
  onSearch,
  searchPlaceholder = "Search...",
  showButton,
  customActions, 
}) => {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    if (onSearch) onSearch(value);
  };

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
      <div className="flex items-center justify-between w-full gap-3 p-4 border">
        {/* Search Input */}
        <div className="relative flex-1 max-w-lg">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 w-5" />
          <input
            type="text"
            value={searchQuery}
            onChange={handleSearchChange}
            placeholder={searchPlaceholder}
            className="w-full shadow-md pl-10 text-sm pr-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-accentTextColor transition"
          />
        </div>

        <div className="flex gap-3 flex-shrink-0">
          {typeof customActions === "function" && customActions()}

          {showButton && (
            <button
              onClick={onButtonClick}
              className="px-6 py-2.5 bg-primaryColor/90 active:scale-[0.98] text-white font-medium rounded-lg hover:bg-primaryColor transition flex items-center gap-2"
            >
              {buttonName}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Heading;

// import { FileText, Search, UserCheck } from "lucide-react";
// import { useState } from "react";
// const Heading = ({
//   buttonName = "Add New",
//   onButtonClick,
//   onSearch,
//   searchPlaceholder = "Search...",
//   showButton,
//   customActions,
// }) => {
//   const [searchQuery, setSearchQuery] = useState("");

//   const handleSearchChange = (e) => {
//     const value = e.target.value;
//     setSearchQuery(value);
//     if (onSearch) onSearch(value);
//   };

//   // Determine if any items are selected
//   const hasSelection = customActions !== null;

//   return (
//     <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 ">
//       <div className="flex items-center justify-between w-full gap-3 p-4 border">
//         {/* Search Input */}
//         <div className="relative flex-1 max-w-60">
//           <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 w-5" />
//           <input
//             type="text"
//             value={searchQuery}
//             onChange={handleSearchChange}
//             placeholder={searchPlaceholder}
//             className="w-full shadow-md pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-accentTextColor transition"
//           />
//         </div>

//         {/* Buttons Area */}
//         <div className="flex gap-3 flex-shrink-0">
//           {customActions}

//           {!hasSelection && (
//             <>
//               {/* Disabled Invoice Button */}
//               <button
//                 disabled
//                 className="px-4 py-2 bg-gray-300 text-gray-500 font-medium rounded-lg flex items-center gap-2 cursor-not-allowed opacity-60"
//               >
//                 <FileText size={20} />
//               </button>
//               {/* Disabled Assign Button */}
//               <button
//                 disabled
//                 className="px-5 py-2.5 bg-primaryBtnColor  text-white font-medium rounded-lg flex items-center gap-2 cursor-not-allowed opacity-60"
//               >
//                 <UserCheck size={18} />
//                 Assign
//               </button>
//             </>
//           )}

//           {/* Add New Button (always visible if showButton=true) */}
//           {showButton && (
//             <button
//               onClick={onButtonClick}
//               className="px-6 py-2.5 bg-primaryBtnColor active:scale-[0.98] text-white font-medium rounded-lg hover:bg-primaryBtnHoverColor transition flex items-center gap-2"
//             >
//               {buttonName}
//             </button>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Heading;
